import { render } from "./LoadScene.vue?vue&type=template&id=2aaf69f6"
import script from "./LoadScene.vue?vue&type=script&lang=js"
export * from "./LoadScene.vue?vue&type=script&lang=js"

import "./LoadScene.vue?vue&type=style&index=0&id=2aaf69f6&lang=css"

import exportComponent from "/tmp/build_4e4571bb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__